import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()


export const getSuccessCriteria = (abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.get("/SuccessStories/ByCriteria", config);
  }